import isSSR from '../../utils/isSSR';
var PRODUCT_LINES;
(function (PRODUCT_LINES) {
    PRODUCT_LINES["HONDA"] = "honda";
    PRODUCT_LINES["ACURA"] = "acura";
})(PRODUCT_LINES || (PRODUCT_LINES = {}));
const CONFIG_ELEMENT_IDS = {
    [PRODUCT_LINES.HONDA]: '#honda-config-app',
    [PRODUCT_LINES.ACURA]: '#acura-config',
};
// eslint-disable-next-line import/prefer-default-export
export const getApiUrl = (appName) => {
    if (isSSR())
        return null;
    const productLine = appName === null || appName === void 0 ? void 0 : appName.toLowerCase();
    const config = document.querySelector(CONFIG_ELEMENT_IDS[productLine]);
    if (!config || config.type !== 'hidden' || !config.dataset)
        return null;
    return config.dataset.userContextUrl;
};
